import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-software-automation',
	path: '/jira/software/projects/:projectKey/settings/automation',
	exact: true,
};
